export default ({ binding }) => {
  return binding?.instance
}
